<template>
    <div class="progbar-cell">
        <div class="progbar">
            <div
                class="progbar_section section_done"
                :style="doneStyles"
                :title="doneTitle"
            ></div>
            <div
                 class="progbar_section section_inprogress"
                 :style="inProgressStyles"
                 :title="inProgressTitle"
            ></div>
            <div
                class="progbar_section section_todo"
                :style="todoStyles"
                :title="todoTitle"
            ></div>
        </div>
    </div>
</template>

<script>

    export default {

        props: {
            items: {
                type: Object,
                required: true,
            },
        },

        methods: {
            barValuePercent(value) {
                return this.barValueTotal === 0 || value === 0
                    ? 0
                    : Math.round((value / this.barValueTotal) * 100);
            },
            totalTodo(key) {
                return this.items.to_do ? this.items.to_do.totals[key] : 0;
            },
            totalInProgress(key) {
                return this.items.in_progress ? this.items.in_progress.totals[key] : 0;
            },
            totalDone(key) {
                return this.items.done ? this.items.done.totals[key] : 0;
            },
        },

        computed: {
            /**
             *      "barValue" methods:
             *      If someone completes an item under estimation, we want to show the 'seconds_todo' for the 'done'
             *      bar section to represent this. If they go over however, we want to show the time they actually
             *      took, and will use 'seconds_done'.
             */
            barValueTodo() {
                return this.totalTodo('seconds_todo');
            },
            barValueInProgress() {
                return Math.max(this.totalInProgress('seconds_done'), this.totalInProgress('seconds_total'));
            },
            barValueDone() {
                return Math.max(this.totalDone('seconds_done'), this.totalDone('seconds_total'));
            },
            barValueTotal() {
                return this.barValueTodo + this.barValueInProgress + this.barValueDone;
            },
            barValueTodoPercent() {
                return this.barValuePercent(this.barValueTodo);
            },
            barValueInProgressPercent() {
                return this.barValuePercent(this.barValueInProgress);
            },
            barValueDonePercent() {
                return this.barValuePercent(this.barValueDone);
            },
            doneTitle() {
                let time = this.$options.filters.format_seconds(this.barValueDone);

                return `Done: ${time} (${this.barValueDonePercent}%)`;
            },
            inProgressTitle() {
                let time = this.$options.filters.format_seconds(this.barValueInProgress);

                return `In Progress: ${time} (${this.barValueInProgressPercent}%)`;
            },
            todoTitle() {
                let time = this.$options.filters.format_seconds(this.barValueTodo);

                return `To Do: ${time} (${this.barValueTodoPercent}%)`;
            },
            doneStyles() {
                return {
                    width: `${this.barValueDonePercent}%`,
                };
            },
            inProgressStyles() {
                return {
                    width: `${this.barValueInProgressPercent}%`,

                };
            },
            todoStyles() {
                return {
                    width: `${this.barValueTodoPercent}%`,
                };
            },
        }

    }
</script>

<style>
    .progbar-cell {
        width: 100%;
        height: 100%;
        display: block;
        position: relative;
        padding: 15px 0;
    }
    .progbar {
        width: 100%;
        border-radius: 2px;
        background-color: #bfbfbf;
        height: 20px;
        overflow: hidden;
        display: block;
        box-shadow: 0 0 20px #000;
    }
    .progbar_section {
        float: left;
        height: 100%;
    }
    .section_done {
        background-color: #218714;
        box-shadow: -3px 0 0 #000 inset;
    }
    .section_inprogress {
        background-color: #807d53;
        box-shadow: -3px 0 0 #000 inset;
    }
    .section_todo {
        background-color: #5d5d5d;
    }
    .progbar-status-ok .progbar_section {
        background-color: #187e18;
        border-right: 1px solid #20602a;
    }
    .progbar.progbar-status-ok {
        border-color: #20602a;
    }
    .progbar-status-warning .progbar_section {
        background-color: #f0be12;
        border-right: 1px solid #a28318;
    }
    .progbar.progbar-status-warning {
        border-color: #a28318;
    }
    .progbar-status-warning .percent {
        color: #000;
    }
    .progbar-status-danger .progbar_section {
        background-color: #b40000;
    }
    .progbar.progbar-status-danger {
        border-color: #350606;
    }
</style>